import { finalize } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { GeneralService } from './../../services/general.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'shc-privacy-policy',
  templateUrl: './privacy-policy.page.html',
  styleUrls: ['./privacy-policy.page.scss'],
})
export class PrivacyPolicyPage implements OnInit {
  privacy: string;

  constructor(
    private generalService: GeneralService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {
    this.getPageContent();
  }

  getPageContent() {
    this.generalService.showLoader();
    this.generalService.getPageContent({ type: 'privacy' }).pipe(
      finalize(() => this.generalService.hideLoader())
    ).subscribe(res => {
      this.privacy = res.content;
    }, error => {
      this.errorService.handle(error);
    });
  }

}
